// Pure member helpers — bulk-name parsing and profile-completion rendering.
//
// `parseBulkNames` powers the bulk-register sheet: paste a list of names (any
// of comma/newline/tab-separated), get back a deduped, trimmed array. Case-
// insensitive dedupe so "안유진" and "안유진 " collapse to one.
//
// `profileCompletionStats` measures the optional fields a member can fill out
// (preferred surface, dominant hand, backhand style); the gauge nudges users
// to complete their profile without blocking sign-up.

import { mountPreact } from "../ui/preact-mount";

export function parseBulkNames(raw: string | null | undefined): string[] {
  const text = String(raw || "");
  const tokens = text
    .split(/[\n\r,\t]+/)
    .map((t) => t.trim())
    .filter(Boolean);
  const seen = new Set<string>();
  const out: string[] = [];
  for (const t of tokens) {
    const key = t.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(t);
  }
  return out;
}

export interface ProfileCompletion {
  filled: number;
  total: number;
  pct: number;
}

export function profileCompletionStats(member: any): ProfileCompletion {
  const fields = [
    !!(member.preferred_surfaces && member.preferred_surfaces.length > 0),
    !!member.dominant_hand,
    !!member.backhand_style,
  ];
  const filled = fields.filter(Boolean).length;
  return { filled, total: fields.length, pct: Math.round((filled / fields.length) * 100) };
}

function ProfileCompletionBar({ filled, total, pct }: ProfileCompletion) {
  return (
    <div class="profile-completion">
      <div class="profile-completion__row">
        <span class="profile-completion__label">프로필 완성도</span>
        <span class="profile-completion__value">{filled}/{total} · {pct}%</span>
      </div>
      <div class="profile-completion__track">
        <div class="profile-completion__fill" style={`width: ${pct}%`} />
      </div>
    </div>
  );
}

export function buildProfileCompletionBar(member: any): HTMLElement | null {
  const stats = profileCompletionStats(member);
  if (stats.pct >= 100) return null;
  return mountPreact(<ProfileCompletionBar {...stats} />);
}
